// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LitertureCard_wrapper__ty1KG"};